import React, { useState, useContext } from "react";
import styled from "styled-components";
import Chip from "@mui/material/Chip";
import EditIcon from "@mui/icons-material/Edit";
import { action } from "variables/action";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomDialog from "components/CustomDialog/CustomDialog";
import EditTabContent from "./EditTabContent";
import { reclevelData, statusData } from "variables/lists/action";

export default function TabContent({
  apiData,
  params,
  category = "",
  groupParent,
}) {
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;

  return (
    <EditTabContent
      apiData={apiData}
      params={params}
      category={category}
      groupParent={groupParent}
    />
  );
}
